import React from 'react';
import { Check } from 'lucide-react';
export function System() {
  const tags = ['+150 págs.', '11 documentos', 'Presupuestos PDF', 'Ficha de Clienta', 'Guiones WhatsApp', 'Menú de Precios', 'Plan de Redes', 'Fidelización', 'Aumento de Precios', 'Control Mensual'];
  const skills = ['Presupuesto profesional', 'Ficha de clienta', 'Consentimiento informado', 'Menú de servicios', 'Mensajes de turno', 'Seguimiento post-sesión', 'Plan de contenido', 'Fidelización de cartera', 'Método de precios', 'Control de ingresos', 'WhatsApp Business', 'Cierre de presupuesto'];
  return <section className="bg-white py-10 sm:py-16 px-5" data-id="element-337">
      <div className="max-w-[860px] mx-auto" data-id="element-338">
        <div className="text-center mb-8 sm:mb-12" data-id="element-339">
          <div className="inline-block bg-rosa text-white text-[11px] font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-3 sm:mb-4" data-id="element-340">
            Sistema N°1 Para Esteticistas en Argentina
          </div>
          <h2 className="text-[clamp(22px,4vw,34px)] font-extrabold leading-[1.2] mb-3 text-oscuro" data-id="element-341">
            Kit completo · 8 Tomos + 3 Bonos · Descargá y Aplicá
          </h2>
          <p className="text-[15px] text-gris" data-id="element-342">
            Todo en un sistema. Todo en orden. Todo listo para usar desde hoy.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-5 sm:mb-7" data-id="element-343">
          {tags.map((tag, idx) => <span key={idx} className="bg-rosa/10 text-rosa text-[12px] font-semibold px-3 py-1 rounded-full border border-rosa/25" data-id="element-344">
              {tag}
            </span>)}
        </div>

        <p className="text-[14px] text-gris mb-4 sm:mb-6 text-center max-w-2xl mx-auto" data-id="element-345">
          Funciona desde hoy en tu celular, tablet o computadora. Sin aprender
          diseño, sin contratar a nadie.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mt-4 sm:mt-5" data-id="element-346">
          {skills.map((skill, idx) => <div key={idx} className="bg-white border border-[#E8E8E8] rounded-lg px-3.5 py-2.5 text-[13px] font-semibold text-oscuro flex items-center gap-2" data-id="element-347">
              <Check size={16} className="text-verde flex-shrink-0 stroke-[3]" data-id="element-348" />
              <span className="leading-tight" data-id="element-349">{skill}</span>
            </div>)}
        </div>
      </div>
    </section>;
}